import React from 'react';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import StarOutlinedIcon from '@mui/icons-material/StarOutlined';
import { COLORS } from '../../utils/colors';

interface EntityInfoCellProps {
  name: string;
  subLabel: 'Account' | 'Project';
}

export function EntityInfoCell({
  name,
  subLabel,
}: EntityInfoCellProps): JSX.Element {
  return (
    <Stack direction="row" alignItems="center" gap={1} sx={{ width: '100%' }}>
      <Box
        sx={{
          width: 40,
          height: 40,
          borderRadius: '14px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
        }}
      >
        <StarOutlinedIcon sx={{ color: COLORS.BRAND.PRIMARY }} />
      </Box>
      <Stack ml={1}>
        <Typography variant="body1" noWrap>
          {name}
        </Typography>
        <Typography variant="body2" color="text.secondary" noWrap>
          {subLabel}
        </Typography>
      </Stack>
    </Stack>
  );
}
